/**
 * SkipLink Component
 * Provides keyboard-only users with a way to skip repetitive navigation
 * @accessibility Critical for keyboard navigation - WCAG 2.4.1 Bypass Blocks
 */
import { cn } from "@/lib/utils";

interface SkipLinkProps {
  /** The ID of the main content element to skip to */
  targetId?: string;
  /** Custom label for the skip link */
  label?: string;
  /** Additional CSS classes */
  className?: string;
}

export const SkipLink = ({
  targetId = "main-content",
  label = "Skip to main content",
  className,
}: SkipLinkProps) => {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-4 focus:left-4",
        "bg-primary text-primary-foreground px-4 py-2 rounded-md font-medium",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        "transition-all duration-200",
        className
      )}
    >
      {label}
    </a>
  );
};

SkipLink.displayName = "SkipLink";
